module.exports = __webpack_public_path__ + "img/tuev-nord-64x64.98c6aeeb.png";